import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { palette } from '../../../../../theme/default';

export const FixCell = ({ row: { original }, makeFixProblem }) => {
  const handleFixProblem = useCallback(() => {
    makeFixProblem(original);
  }, [makeFixProblem, original]);

  return (
    <Typography
      sx={{
        color: palette.text.browseFile,
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: '16px',
        mr: '26px',
      }}
      onClick={handleFixProblem}
    >
      Fix
    </Typography>
  );
};

FixCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({}),
  }).isRequired,
  makeFixProblem: PropTypes.func.isRequired,
};
